import { AbstractQueueService } from '@telecom/shared/services/queue';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { TaskQueueService } from '../task-queue-service';
import type { TaskExecute } from '../../types';

@injectable()
export class TaskQueueServiceImpl extends AbstractQueueService<TaskExecute> implements TaskQueueService {}
